import { z } from 'zod';

export const StorageEntryMetadataSchema = z.object({
  version: z.number(),
  timestamp: z.number(),
  hash: z.string(),
  size: z.number(),
  compressed: z.boolean(),
  key: z.string().optional(),
  conflictMarkers: z.array(z.string()).optional(),
}).passthrough();

export const StorageEntrySchema = z.object({
  data: z.string(),
  metadata: StorageEntryMetadataSchema,
  compressed: z.boolean().optional(),
}).passthrough();

// Array of StorageEntry — used for version history lists
export const StorageEntryArraySchema = z.array(StorageEntrySchema);

export const SyncOperationSchema = z.object({
  id: z.string().optional(),
  type: z.string().optional(),
  payload: z.unknown().optional(),
  timestamp: z.number().optional(),
}).passthrough();

export const SyncOperationArraySchema = z.array(SyncOperationSchema);

export const OfflineStorageSchema = z.object({
  operations: z.array(z.unknown()).optional(),
  cachedData: z.array(z.unknown()).optional(),
  lastSyncTimes: z.array(z.unknown()).optional(),
}).passthrough();

// SyncQueue schema for BackendSynchronization pending operations
export const SyncQueueItemSchema = z.object({
  id: z.string(),
  type: z.enum(["project", "pages", "components", "version"]),
  operation: z.enum(["create", "update", "delete"]),
  projectId: z.string(),
  pageId: z.string().optional(),
  data: z.unknown(),
  version: z.number().optional(),
  timestamp: z.number(),
  priority: z.enum(["low", "medium", "high", "critical"]),
  retryCount: z.number(),
  maxRetries: z.number(),
  optimisticUpdateId: z.string().optional(),
});

export const SyncQueueSchema = z.array(SyncQueueItemSchema);

export const QueryHistoryItemSchema = z.object({
  id: z.string().optional(),
  query: z.string(),
  timestamp: z.number().optional(),
}).passthrough();

export const QueryHistorySchema = z.array(QueryHistoryItemSchema);

// VersionBranch base fields for localStorage branch data
const VersionBranchBaseFields = {
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  baseVersion: z.number(),
  headVersion: z.number(),
  createdBy: z.string(),
  createdAt: z.union([z.string(), z.number()]),
  updatedAt: z.union([z.string(), z.number()]),
  isProtected: z.boolean(),
  mergedAt: z.union([z.string(), z.number()]).optional(),
  mergedBy: z.string().optional(),
  status: z.enum(["active", "merged", "closed"]),
};

export const RecentBranchRawSchema = z.object({
  ...VersionBranchBaseFields,
  lastAccessed: z.union([z.string(), z.number()]),
  accessCount: z.number().optional(),
}).passthrough();

export const RecentBranchArraySchema = z.array(RecentBranchRawSchema);

export const FavoriteBranchRawSchema = z.object({
  ...VersionBranchBaseFields,
  addedToFavorites: z.union([z.string(), z.number()]),
  favoriteOrder: z.number().optional(),
}).passthrough();

export const FavoriteBranchArraySchema = z.array(FavoriteBranchRawSchema);
